'use strict'

import React from 'react';
import MediaQuery from 'react-responsive';

import { getHistory } from '@/history';
import { getWeekStartFromRef } from '@/state/utilities';

import LoginPage from './views/pages/login';
import UserLayout from './views/layouts/user';

import UserPage, { components as userPageComps } from './views/pages/user';
import Header from './views/common/Header';
import UserMenu from './views/pages/user/Menu';

import JobsPage, { components as jobsPageComps } from './views/pages/jobs';
import PlacesPage, { components as placesPageComps } from './views/pages/places';
import UsersPage, { components as usersPageComps } from './views/pages/users';
import SettingsPage, { components as settingsPageComps } from './views/pages/settings';
import DailyPage, { components as dailyPageComps } from './views/pages/daily';
import LocationPage, { components as locationPageComps } from './views/pages/location';
import NoJobLocationPage, { components as noJobLocationPageComps } from './views/pages/noJobLocation';
import AttemptsPage from './views/pages/attempts';
//import { fetchUserWeeklyAttempts } from '@/state/domains/attempts/actions';

const setUrlParams = (store, params) => store.dispatch({
	type: 'app/UPDATE_URL_PARAMS',
	data: params,
});

const setPageId = (store, pageId) => store.dispatch({
	type: 'app/SET_PAGE_ID',
	data: pageId,
});

let _p, _pid;

export default [
	{
		path: '/',
		action: () => {
			return <LoginPage />
		},
	},
	{
		path: '/jobs',
		action: async ({ params, next, store }) => {

			const { users } = store.getState();
			const { loggedInUser: user } = users;

			if (!user) {
				return { redirect: '/' };
			}

			_p = params;
			_pid = 'jobs';

			let child = await next();

			setUrlParams(store, params);
			setPageId(store, _pid);

			const defaultComps = {
				header: Header,
				overlays: [ UserMenu ],
				main: JobsPage,
			};

			const childComp = {
				...defaultComps,
				...child,
			};

			return (
				<UserLayout
					username={ user.username }
					header={ childComp.header }
					main={ childComp.main }
					overlays={ childComp.overlays }
				/>
			);
		},
	},
	{
		path: '/places',
		action: async ({ params, next, store }) => {

			const { users } = store.getState();
			const { loggedInUser: user } = users;

			if (!user) {
				return { redirect: '/' };
			}

			_p = params;
			_pid = 'places';

			let child = await next();

			setUrlParams(store, params);
			setPageId(store, _pid);

			const defaultComps = {
				header: Header,
				overlays: [ UserMenu ],
				main: PlacesPage,
			};

			const childComp = {
				...defaultComps,
				...child,
			};

			return (
				<UserLayout
					username={ user.username }
					header={ childComp.header }
					main={ childComp.main }
					overlays={ childComp.overlays }
				/>
			);
		},
	},
	{
		path: '/users',
		action: async ({ params, next, store }) => {

			const { users } = store.getState();
			const { loggedInUser: user } = users;

			if (!user) {
				return { redirect: '/' };
			}

			_p = params;
			_pid = 'users';

			let child = await next();

			setUrlParams(store, _p);
			setPageId(store, _pid);

			const defaultComps = {
				header: Header,
				overlays: [ UserMenu ],
				main: usersPageComps.main,
			};

			const childComp = {
				...defaultComps,
				...child,
			};

			return (
				<UserLayout
					username={ user.username }
					header={ childComp.header }
					main={ childComp.main }
					overlays={ childComp.overlays }
				/>
			);
		},
	},
	{
		path: '/user/:username',
		action: async ({ params, next, store }) => {

			const history = getHistory();
			const pageUrl = history.location.pathname;
			const { username } = params;

			let child = await next();
			
			setUrlParams(store, _p);
			setPageId(store, _pid);

			if (!child) {
				
				const { users } = store.getState();
				const { loggedInUser: user } = users;

				if (!user) {
					return { redirect: '/' };
				}

				const weekStart = getWeekStartFromRef(user, new Date());

				return { redirect: `/user/${ username }/${ weekStart }` };
			}

			const defaultComps = {
				header: Header,
				overlays: [ UserMenu ],
				main: UserPage,
			};

			const childComp = {
				...defaultComps,
				...child,
			};

			return (
				<UserLayout
					username={ username }
					header={ childComp.header }
					main={ childComp.main }
					overlays={ childComp.overlays }
				/>
			);
		},
		children: [
			{
				path: '/settings',
				action: ({ params, store }) => {
					_p = params;
					_pid = 'settings';
					return settingsPageComps
				},
			},
			{
				path: '/:date([0-9]{4}-[0-9]{2}-[0-9]{2})',
				action: async ({ params, next, store }) => {

					_p = params;
					_pid = 'user-weekly';
					let child = await next();
			
					if (!child) {
						return userPageComps;
					}

					return child;
				},
				children: [
					{
						path: '/route',
						action: ({ params, store }) => {
							_p = params;
							_pid = 'daily-route';
							return dailyPageComps;
						}
					},
					{
						path: '/attempts',
						action: ({ params, store }) => {
							_p = params;
							_pid = 'daily-attempts';
							return <AttemptsPage />
						},
					},
					{
						path: '/location/:hashLocationId',
						action: ({ params, store }) => {
							_p = params;
							_pid = 'daily-nojob';
							return noJobLocationPageComps;
						},
					},
					{
						path: '/:companyId/:jobId/:hashLocationId',
						action: ({ params, store }) => {
							_p = params;
							_pid = 'daily-location';
							return locationPageComps;
						},
					},
				],
			},
		],
	},
];
